









import { defineComponent } from '@vue/composition-api'
import ExternalConfirmationSection from '@/components/common/ExternalConfirmation/ExternalConfirmationSection.vue'

/**
 * アプリ版: 有料会員解約 ペイン
 */
export default defineComponent({
  name: 'MypageCancelPaidPlanEditPane',
  components: {
    ExternalConfirmationSection,
  },
})
